export const menuActions = {
    SET_MENU: 'SET_MENU',
    GET_MENU: 'GET_MENU',
    SET_BREADCRUMB: 'SET_BREADCRUMB'
};

const initState = [];

export const menuReducer = (state = initState, action: any) => {
    switch (action.type) {
        case menuActions.SET_MENU:
            return Object.assign({}, state, action.payload);

        case menuActions.SET_BREADCRUMB:
            return Object.assign({}, state, { breadcrumb: action.payload });

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/menuReducer.ts